<template>
  <div>
    <div class="row">
      <br>
      <div class="col-md-6">
        <label for="formato">Formato:</label>
        <select v-model="formato" id="formato" class="form-control">
          <option value="1">Autorización</option>
          <option value="2">Orden médica</option>
        </select>
      </div>
    </div>
    <!-- <center> -->
      <div class="row">
        <div class="col-md-12">
          <br>
          <p style="font-weight: bold; margin-bottom: 15px;">Selecciona al paciente</p>
        </div>
        <div class="col-md-4">
          <label for="buscarPacientePor">Buscar por</label>
          <select class="form-control" id="buscarPacientePor" v-model="criterio">
            <option value="PacApe1">Apellidos del paciente</option>
            <option value="PacNom1">Nombres del paciente</option>
          </select>
        </div>
        <div class="col-md-7">
          <label for="buscarPaciente">Buscar</label>
          <input
            type="text"
            placeholder="Escribe lo que quieres buscar..."
            id="buscarPaciente"
            class="form-control"
            @keyup.enter="buscarPacientes()"
            v-model="busqueda"
          />
        </div>
        <div class="col-md-1">
          <br>
          <button
            class="btn btn-link btn-icon btn-success btn-simple"
            @click="buscarPacientes()"
          >
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <br />
    <!-- </center> -->
    <center>
      <div class="row" v-if="buscar == false">
        <div>
          <el-table
            :data="arrayPacientes"
            border
            size="mini"
            style="width: 97%"
            class="table-responsive"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="PacApe1" label="Apellidos"></el-table-column>
            <el-table-column prop="PacNom1" label="Nombres"></el-table-column>
            <el-table-column prop="PacNumDoc" label="N° documento"></el-table-column>
            <el-table-column prop="TipCliNom" label="Tipo de cliente"></el-table-column>
            <el-table-column width="100">
              <template slot-scope="props">
                <center>
                  <a
                  class="btn btn-simple btn-success btn-xs btn-icon like"
                  @click="seleccionarPaciente(props.row)"
                  v-if="props.row.estado==1"
                >
                  <i class="fa fa-check"></i>
                </a>
                <small v-else class="text-danger">INACTIVO</small>
                </center>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </center>
      <div class="row" v-if="nombre != ''">
        <div class="col-md-6">
          <label for>Nombre</label>
          <input
            type="text"
            class="form-control"
            readonly
            v-model="nombre"
          />
          <small class="text-danger" v-if="alertTipoCliente">El tipo de cliente no concueda con el modulo seleccionado</small>
        </div>
        <div class="col-md-6">
          <label for>Documento</label>
          <input
            type="text"
            class="form-control"
            disabled
            v-model="documento"
          />
        </div>
        <!-- <div class="col-md-2 text-success">
          <label for>Cod. único</label>
          <p style="font-size: 19px">{{ pacIde }}</p>
        </div> -->
      </div>
    <br />
    <div style="padding: 10px;" v-if="formato == 1">
      <div class="row">
        <div class="col-md-12">
          <center>
            <label style="font-weight: 600;">Registrar como codigo 90</label>
            <br />
            <br />
            <switches
              v-model="c90"
              type-bold="true"
              theme="bootstrap"
              color="success"
            ></switches>
          </center>
        </div>
      </div>
      <div class="row" v-if="c90 == false">
        <div class="col-md-12">
           <p style="font-weight: 600;">
            Información de la orden
          </p>
        </div>
      </div>
      <div class="row" v-if="tablaOrden == true && c90 == false">
        <div class="col-md-12">
          <el-table
          :data="arrayOrdenes"
          border
          style="width: 100%"
          class="table-responsive"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="OrdCod" label="Codigo"></el-table-column>
          <el-table-column prop="OrdFec" label="Fecha"></el-table-column>
          <el-table-column prop="EpsNom" label="Entidad"></el-table-column>
          <el-table-column >
            <template slot-scope="props">
              <center>
                <button
                class="btn btn-success btn-fill"
                @click="seleccionarOrden(props.row)"
              >
                Seleccionar
            </button>
              </center>
              
            </template>
          </el-table-column>
        </el-table>
        </div>
        <br> <br>
      </div>
      <div class="row" v-if="c90 == false">
        <br>
        <div class="col-md-4">
          <label for>N° de orden:</label>
          <input
            type="text"
            class="form-control"
            v-model="numeroOrden"
            disabled
          />
        </div>
        <div class="col-md-4">
          <label for>Entidad:</label>
          <input
            type="text"
            class="form-control"
            v-model="eps"
            disabled
          />
        </div>
        <div class="col-md-4">
          <label for>Fecha de expedición:</label>
          <input
            type="text"
            class="form-control"
            v-model="fechaExpedicion"
            disabled
          />
        </div>
        <div class="col-md-4">
          <label for>Fecha de vencimiento:</label>
          <input
            type="text"
            class="form-control"
            v-model="fechaVencimiento"
            disabled
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <p style="font-weight: 600;">
          Información de la autorización
          
        </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label for>N° de autorización:</label>
          <input
            type="text"
            class="form-control"
            disabled
            v-model="numeroAutorizacion"
          />
        </div>
        <div class="col-md-4">
          <label for>Fecha de expedición:</label>
          <input
            type="date"
            @change="generarCodigoAutorizacion()"
            class="form-control"
            v-model="fechaExpedicionAutorizacion"
          />
        </div>
        <div class="col-md-4">
          <label for>Cobertura:</label>
          <select
            v-model="coberturaAutorizacion"
            class="form-control"
            id
          >
            <option value="45">45 Días</option>
            <option value="30">1 Mes</option>
            <option value="60">2 Meses</option>
            <option value="90">3 Meses</option>
            <option value="120">4 Meses</option>
            <option value="150">5 Meses</option>
            <option value="180">6 Meses</option>
          </select>
        </div>
        <div class="col-md-4">
          <label for>Observaciones:</label>
          <textarea class="form-control" id="observaciones" v-model="observaciones" cols="30" rows="3"></textarea>
        </div>
      </div>
    </div>
    <br />
    <div style="padding:10px;" v-if="formato == 2 & nombre!= ''">
      <div class="row">
        <div class="col-md-12">
          <p style="font-weight: 600;">
          Inoformacion de la orden
        </p>
        <br>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <input
            type="radio"
            @change="selectEps()"
            v-model="regimen"
            value="1"
          />
          <label for>Contributivo</label> &nbsp; &nbsp;
          <input
            type="radio"
            @change="selectEps()"
            v-model="regimen"
            value="2"
          />
          <label for>Subsidiado</label>
        </div>
        <div class="col-md-4">
          <select
            class="form-control"
            v-model="eps"
            @change="generarCodigo()"
          >
            <option value selected disabled>Seleccione la EPS...</option>
            <option
              v-for="eps in arrayEps"
              :key="eps.EpsCod"
              :value="eps.EpsCod"
              v-text="eps.EpsNom"
            ></option>
          </select>
        </div>
        <div class="col-md-4">
          <input
            type="text"
            class="form-control"
            v-model="numeroOrden"
            disabled
            placeholder="Numero de la orden"
          />
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-4">
          <label for>Fecha de expedición</label>
          <input
            type="date"
            v-model="fechaExpedicion"
            @change="generarCodigo()"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label>Cobertura</label>
          <select v-model="cobertura" class="form-control">
            <option value="45">45 Días</option>
            <option value="30">1 Mes</option>
            <option value="60">2 Meses</option>
            <option value="90">3 Meses</option>
            <option value="120">4 Meses</option>
            <option value="150">5 Meses</option>
            <option value="180">6 Meses</option>
          </select>
        </div>
      </div>
      <br />
    </div>
      <div class="row" style="padding:10px" v-if="nombre != ''">
       <div class="col-md-12">
         <p style="font-weight: 600;">
          Servicios
        </p>
       </div>
      </div>
      <div class="row" style="padding:10px;" v-if="nombre != ''">
        <form @submit.prevent="agregarServicios">
          <div class="col-md-4">
            <label>Servicio</label>
            <select class="form-control" v-model="especialidad">
              <option
                :value="[especialidad.EspCod, especialidad.EspNom]"
                v-for="especialidad in arrayEspecialidad"
                :key="especialidad.EspCod"
              >
                {{ especialidad.EspNom }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Cantidad</label>
            <input
              type="text"
              class="form-control"
              v-model="cantidad"
              required
            />
          </div>
          <div class="col-md-1">
            <br>
            <button type="submit" class="btn btn-icon btn-simple btn-success">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </form>
      </div>
      <br />
      <div class="row" style="padding:10px" v-if="arrayCantidad != ''">
        <div class="col-md-12">
          <el-table
          :data="arrayCantidad"
          border
          style="width: 100%"
          class="table-responsive table-bordered"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="servicio" label="Cups"></el-table-column>
          <el-table-column prop="nombre" label="Nombre"></el-table-column>
          <el-table-column prop="cantidad" label="Cantidad"></el-table-column>
          <el-table-column label width="50">
            <template slot-scope="props">
              <!-- <a class="btn btn-simple btn-xs btn-info btn-icon like" @click="handleLike(props.$index, props.row)"><i class="ti-heart"></i></a> -->
              <!-- <a class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a> -->
              <a
                class="btn btn-simple btn-xs btn-danger btn-icon remove"
                @click="eliminarServicio(props.$index, props.row)"
              >
                <i class="ti-close"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </div>
      <br />
      <div
        class="alert alert-danger"
        v-if="mensaje != null"
        style="color: white"
      >
        <span>
          {{ mensaje }}
          <i :class="'fa fa-' + icono"></i>
        </span>
      </div>
      <center>
        <div class="row">
          <button
            class="btn btn-success btn-fill btn-sm"
            @click="nuevaAutorizacionSinOM()"
            v-if="formato == 1 && boton == true && c90 == true"
          >
            Registrar Autorización "codigo 90"
          </button>
          <button
            class="btn btn-success btn-fill"
            @click="nuevaAutorizacion()"
            v-if="formato == 1 && boton == true && c90 == false"
          >
            Registrar Autorización
          </button>
          <button
            class="btn btn-success btn-fill"
            @click="nuevaOrdenMedica()"
            v-if="formato == 2 && boton == true"
          >
            Registrar Orden médica
          </button>
          <button class="btn btn-danger" @click="cerrar()">
            Cancelar
          </button>
        </div>
      </center>
    <br />
  </div>
</template>
<script>
import axios from "axios";
import Switches from "vue-switches";
export default {
  data() {
    return {
      c90: false,
      formato: 1,
      criterio: "PacApe1",
      buscar: true,
      arrayPacientes: [],
      busqueda: "",
      ip: "https://avanti-erp.com/",
      nombre: "",
      documento: "",
      pacIde: "",
      alertTipoCliente: '',
      numeroOrden: "",
      eps: "",
      cobertura: "",
      regimen: 1,
      fechaExpedicion: "",
      fechaVencimiento: "",
      arrayCantidad: [],
      arrayEspecialidad: [],
      cantidad: "",
      observaciones: '',
      epsCod: "",
      especialidad: "",
      arrayOrdenes: [],
      tablaOrden: false,
      numeroAutorizacion: "",
      fechaExpedicionAutorizacion: "",
      coberturaAutorizacion: "",
      arrayEps: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      boton: true,
      mensaje: null,
      icono: null,
      bolsa: 0,
    };
  },
  components: {
    Switches,
  },
  methods: {
    eliminarServicio: function (index, fila) {
      this.arrayCantidad.splice(index, 1);
      // console.log(fila, 'posible servicio')
      this.bolsa = this.bolsa - parseInt(fila.cantidad)
      console.log('Bolsa', this.bolsa);
    },
    buscarPacientes() {
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      this.arrayPacientes = [];
      let vm = this;
      var url =
        this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      axios
        .get(url, config)
        .then((response) => {
          vm.arrayPacientes = response.data.data;
          this.buscar = false;
          console.log(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    seleccionarPaciente(paciente) {
     

      if(paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")){
        const alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
      if(alerta == true){
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = true;

        setTimeout(() => {
          this.cargarOrdenes();
        }, 1000);
      }
      }else{
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;

        setTimeout(() => {
          this.cargarOrdenes();
        }, 1000);
      }

      
    },
    generarCodigo() {
      this.numeroOrden = "EPS-" + this.pacIde + "-" + this.fechaExpedicion;
    },
    selectEspecialidad() {
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var url = this.ip + "api/selectEspecialidad";
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data.data;
          this.arrayEspecialidad = respuesta;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad[0],
          cantidad: this.cantidad,
          nombre: this.especialidad[1],
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        console.log("Bolsa", this.bolsa);

        this.cantidad = "";
        this.especialidad = "";
      }
    },
    cargarOrdenes() {
      var token = localStorage.getItem("token");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var url = this.ip + "api/cargarOrdenesActivas/" + this.pacIde + "/eps";
      axios
        .get(url, config)
        .then((response) => {
          this.arrayOrdenes = response.data.data;
          // console.log(arrayOrdenes);
          this.tablaOrden = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    seleccionarOrden(orden) {
      this.tablaOrden = false;
      this.numeroOrden = orden.OrdCod;
      this.eps = orden.EpsNom;
      this.fechaExpedicion = orden.OrdFec;
      this.fechaVencimiento = orden.OrdVen;
      this.numeroAutorizacion = "EPS-AUT-" + this.pacIde;
      this.epsCod = orden.CodEnt;
    },
    selectEps() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var url = this.ip + "api/selectEps?reg=" + this.regimen;
      axios
        .get(url, config)
        .then((response) => {
          var respuesta = response.data;
          this.arrayEps = respuesta.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nuevaAutorizacionSinOM() {
      if (this.bolsa == 0) {
        alert("Debe cargar servicios");
      } else {
        this.$modal.show("carga");
        let config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };
        if (this.coberturaAutorizacion == "") {
          this.fechaVencimientoAutorizacion = "";
          this.cobertura = 0;
        } else {
          this.calcularFechaAutorizacion();
          let url = this.ip + "api/nuevaAutorizacionSinOM";
          axios
            .post(
              url,
              {
                codigoOrden: this.numeroAutorizacion,
                tipoServicio: "adm",
                entidad: 16,
                fechaOrden: this.fechaExpedicionAutorizacion,
                cobertura: this.coberturaAutorizacion,
                fechaVencimiento: this.fechaVencimientoAutorizacion,
                paciente: this.pacIde,
                servicios: this.arrayCantidad,
                formato: 1,
                pertenece: "avanza",
                usuario: localStorage.getItem("usuario"),
                bolsa: this.bolsa,
                observacion: this.observaciones
              },
              config
            )
            .then((response) => {
              var color = Math.floor(Math.random() * 4 + 1);
              this.$notify({
                component: {
                  template: `<span>!<b> Autorización registrada con éxito!</b>.</span>`,
                },
                icon: "ti-check",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: this.type[color],
              });
              this.bolsa = 0;
              // this.criterio = "";
              // this.busqueda = "";
              // this.numeroOrden = "";
              // this.numeroAutorizacion = "";
              // this.fechaVencimientoAutorizacion = "";
              // this.fechaExpedicionAutorizacion = "";
              // this.coberturaAutorizacion = "";
              // this.eps = "";
              // this.fechaExpedicion = "";
              // this.cobertura = "";
              // this.fechaVencimiento = "";
              // this.pacIde = "";
              // this.arrayCantidad = "";
              // this.pacIde = "";
              // (this.arrayPacientes = ""), (this.formato = 1);
              // (this.nombre = ""), (this.documento = "");
              // this.fechaExpedicion = "";
              this.$modal.hide("carga");
              this.cerrar();
            })
            .catch((error) => {
              console.log(error);
              this.$modal.hide("carga");
            });
        }
      }
    },
    calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);
      // this.fechaVencimiento = fechaFin.getDate() + '/' + (fechaFin.getMonth() + 1) + '/' + fechaFin.getFullYear();
      // this.fechaVencimiento = new Date("2019/10/21");
      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 && dia < 10) {
        this.fechaVencimiento = ano + "-" + "0" + mes + "-" + "0" + dia;
        this.fechaVencimientoAutorizacion =
          ano + "-" + "0" + mes + "-" + "0" + dia;
      } else {
        this.fechaVencimiento = ano + "-" + mes + "-" + dia;
        this.fechaExpedicionAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    calcularFechaAutorizacion() {
      var dias = parseInt(this.coberturaAutorizacion);
      var fechaInicio = new Date(this.fechaExpedicionAutorizacion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);
      // this.fechaVencimiento = fechaFin.getDate() + '/' + (fechaFin.getMonth() + 1) + '/' + fechaFin.getFullYear();
      // this.fechaVencimiento = new Date("2019/10/21");
      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 && dia < 10) {
        this.fechaVencimientoAutorizacion =
          ano + "-" + "0" + mes + "-" + "0" + dia;
      } else {
        this.fechaVencimientoAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    nuevaOrdenMedica() {
      if (this.bolsa == 0) {
        alert("Debe cargar servicios para poder ingresar la Orden médica");
      } else {
        this.boton = false;
        let config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };
        this.calcularFecha();
        let url = this.ip + "api/nuevaOrdenMedica";
        axios
          .post(
            url,
            {
              codigoOrden: this.numeroOrden,
              tipoServicio: "eps",
              entidad: this.eps,
              fechaOrden: this.fechaExpedicion,
              cobertura: this.cobertura,
              fechaVencimiento: this.fechaVencimiento,
              paciente: this.pacIde,
              servicios: this.arrayCantidad,
              formato: 0,
              bolsa: this.bolsa
            },
            config
          )
          .then((response) => {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>!<b> Orden médica registrada con éxito!</b>.</span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
            this.criterio = "";
            this.busqueda = "";
            this.numeroOrden = "";
            this.eps = "";
            this.fechaExpedicion = "";
            this.cobertura = "";
            this.fechaVencimiento = "";
            this.pacIde = "";
            this.arrayCantidad = "";
            this.pacIde = "";
            (this.arrayPacientes = ""), (this.formato = 1);
            (this.nombre = ""), (this.documento = "");
            this.fechaExpedicion = "";
            this.$modal.hide("ingreso_servicio");
            this.buscar = true;
            this.boton = true;
            this.bolsa = 0;
          })
          .catch((error) => {
            console.log(error);
            this.boton = true;
          });
      }
    },

    nuevaAutorizacion() {
      if (this.bolsa == 0) {
        alert("Debe cargar servicios para ingresar autorización");
      } else {
        this.boton = false;
        let config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };
        this.calcularFechaAutorizacion();
        let url = this.ip + "api/nuevaAutorizacion";
        axios
          .post(
            url,
            {
              codigoOrden: this.numeroAutorizacion,
              tipoServicio: "eps",
              entidad: this.epsCod,
              fechaOrden: this.fechaExpedicionAutorizacion,
              cobertura: this.coberturaAutorizacion,
              fechaVencimiento: this.fechaVencimientoAutorizacion,
              paciente: this.pacIde,
              servicios: this.arrayCantidad,
              formato: 1,
              pertenece: this.numeroOrden,
              bolsa: this.bolsa,
              observacion: this.observaciones,
              usuario: localStorage.getItem("usuario"),
            },
            config
          )
          .then((response) => {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>!<b> Autorización registrada con éxito!</b>.</span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });
            this.criterio = "";
            this.busqueda = "";
            this.numeroOrden = "";
            this.numeroAutorizacion = "";
            this.fechaVencimientoAutorizacion = "";
            this.fechaExpedicionAutorizacion = "";
            this.coberturaAutorizacion = "";
            this.eps = "";
            this.fechaExpedicion = "";
            this.cobertura = "";
            this.fechaVencimiento = "";
            this.pacIde = "";
            this.arrayCantidad = "";
            this.pacIde = "";
            (this.arrayPacientes = ""), (this.formato = 1);
            (this.nombre = ""), (this.documento = "");
            this.fechaExpedicion = "";
            this.$modal.hide("ingreso_servicio");
            this.buscar = true;
            this.boton = true;
            this.bolsa = 0;
          })
          .catch((error) => {
            console.log(error);
            this.boton = true;
          });
      }
    },
    generarCodigoAutorizacion() {
      this.numeroAutorizacion =
        "EPS-AUT" + this.pacIde + "-" + this.fechaExpedicionAutorizacion;
    },
    cerrar() {
      this.$modal.hide("ingreso_servicio");
    },
  },
  props: ["modal"],
  mounted() {
    this.selectEspecialidad();
    this.selectEps();
  },
};
</script>
<style scoped>

.btn {
  border-radius: 7px !important;
}

label {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Admisiones/formularios/eps.vue